import {AnalyticsPropertyMaxLength} from '@/services/analytics/analytics-types';
import {RecordWithStringValuesOfMaxLength} from '@/types/utils';

const trackingKeys = {
  // Allocation
  ADD_ALLOCATION: 'ajouter-repartition',
  EDIT_ALLOCATION: 'modifier-repartition',
  DELETE_ALLOCATION: 'supprimer-repartition',
  SAVE_ALLOCATION: 'sauvegarder-repartition',
  ADD_ALLOCATION_ACCOUNT: 'ajouter-compte-repartition',
  REMOVE_ALLOCATION_ACCOUNT: 'supprimer-compte-repartition',
  CANCEL_EDIT_ALLOCATION: 'annuler-modification-repartition',
  // Profile
  VIEW_ADVISOR_PROFILE_TAB: 'voir-profil-conseiller',
  VIEW_PREDETERMINED_ALLOCATIONS_TAB: 'voir-repartitions-preetablies',
  SAVE_ADVISOR_PROFILE: 'enregistrer-profil-conseiller',
  // Application Header
  RETURN_TO_HOMEPAGE: 'retourner-accueil',
  OPEN_MY_REQUESTS: 'ouvrir-mes-demandes',
  OPEN_PROFILE_MENU: 'ouvrir-menu-profil',
  VIEW_MY_PROFILE: 'voir-mon-profil',
  LOGOUT: 'deconnexion',
  // Document Menu
  RETRY_FETCH_DOCUMENTS: 'reessayer-recuperer-documents',
  DELETE_SENT_DOCUMENT_HISTORY: 'supprimer-historique-docs-envoyes',
  OPEN_DOCUMENT: 'ouvrir-document',
  OPEN_DOCUMENT_OPTIONS: 'ouvrir-options-document',
  RETRY_DOCUMENT: 'reessayer-document',
  RESEND_DOCUMENT: 'renvoyer-document',
  EDIT_DOCUMENT: 'modifier-document',
  RETRY_FINAL_SUBMIT: 'reessayer-envoi-final',
  DELETE_DOCUMENT: 'supprimer-document',
  VIEW_INCOMPLETE_DOCUMENTS: 'voir-documents-incomplets',
  VIEW_PENDING_DOCUMENTS: 'voir-documents-attente',
  VIEW_SENT_DOCUMENTS: 'voir-documents-envoyes',
  // Create new document
  CREATE_NEW_REQUEST: 'creer-nouvelle-demande',
  SELECT_NEW_CONTRACT_HOLDER: 'selectionner-nouveau-preneur',
  SELECT_EXISTING_CONTRACT_HOLDER: 'selectionner-preneur-existant',
  SELECT_ACCOUNT: 'selectionner-compte',
  RETRY_ACCOUNTS_ERROR: 'reessayer-erreur-comptes',
  RELOAD_EMPTY_ACCOUNTS: 'recharger-comptes-vides',
  CREATE_NEW_ACCOUNT: 'creer-nouveau-compte',
  // Document sections menu
  OPEN_SECTIONS_MENU: 'ouvrir-menu-sections',
  SELECT_SECTION: 'selectionner-section',
  CLEAR_CURRENT_SECTION: 'effacer-section-courante',
  SUBMIT_DOCUMENT: 'soumettre-document',
  NEXT_DOCUMENT_STEP: 'etape-suivante-document',
  // Document
  OPEN_FIELD_HELP: 'ouvrir-aide',
  DOCUMENT_BUTTON_FIELD: 'champ-du-document',
  VIEW_DOCUMENT_SUMMARY: 'afficher-apercu-document',
  DOWNLOAD_ATTACHMENT_ERROR: 'erreur-telecharge-piece-jointe',
  // Confirmation modal
  CANCEL_CONFIRMATION: 'modale-confirmation-annuler',
  CONFIRM_DISCARD: 'modale-confirmation-abandonner',
  CONFIRM_SAVE: 'modale-confirmation-sauvegarder',
  // Components
  CLOSE_DIALOG: 'fermer-modale',
  DELETE_GROUP_ENTRY: 'supprimer-entree-groupe',
  CANCEL_GROUP_EDIT: 'annuler-modification-groupe',
  SAVE_GROUP_EDIT: 'enregistrer-modification-groupe',
  CANCEL_NEW_GROUP: 'annuler-nouveau-groupe',
  ADD_GROUP_ENTRY: 'ajouter-entree-groupe',
  // Application state pages
  NOT_FOUND_RETURN_HOME: 'non-trouve-retour-accueil',
  ADVISOR_PROFILE_ERROR_LOGOUT: 'erreur-profile-deconnexion',
  // Utilities
  DISABLED: 'disabled',
} as const;

export const WEB_CLICK_TRACKING_KEY: RecordWithStringValuesOfMaxLength<
  typeof trackingKeys,
  AnalyticsPropertyMaxLength
> = trackingKeys;
